import ScrollLock from '../scroll_lock/scroll_lock';
import { logErrorIfElementIsMissing, populateModalObject } from './utils';

class ModalHandler {
    private modals: Record<string, { isVisible: boolean }>;
    private scrollLockStore: ScrollLock;

    constructor(scrollLock: ScrollLock) {
        this.init();
        this.scrollLockStore = scrollLock;
    }

    init() {
        const modalBlocks = document.querySelectorAll('.js-modal-overlay');
        this.modals = populateModalObject(modalBlocks as NodeListOf<HTMLElement>);
    }

    openModal(id: string) {
        if (!id) {
            logErrorIfElementIsMissing(id);
            return;
        }

        this.scrollLockStore.setBodyScrollable(true);

        this.modals[id].isVisible = true;
    }

    closeModal(id: string) {
        if (!id) {
            logErrorIfElementIsMissing(id);
            return;
        }

        this.scrollLockStore.setBodyScrollable(false);

        this.modals[id].isVisible = false;
    }

    getModals() {
        return this.modals;
    }
}

export default ModalHandler;
